import SmoothScroll from 'smooth-scroll'
import { $1 } from '../util'

const NavbarManager = (() => {
  const initSmoothScroll = () => {
    const scroll = new SmoothScroll('a[href*="#"]', {
      ignore: '[data-scroll-ignore]',
      header: '.c-nav',
      speed: 700,
      easing: 'easeInOutCubic',
    })
  }

  const toggleMobileMenu = () => {
    const opener = $1('.js-mobile-open')
    const close = $1('.js-mobile-close')

    if (opener) {
      opener.addEventListener('click', () => {
        document.body.classList.add('is-mobile-open')
      })
    }

    if (close) {
      close.addEventListener('click', () => {
        document.body.classList.remove('is-mobile-open')
        document.body.classList.remove('is-sub-mobile-open')
      })
    }
  }

  const toggleMobileSubLinks = () => {
    const opener = $1('.js-sub-mobile-open')
    const close = $1('.js-sub-mobile-close')

    if (opener) {
      opener.addEventListener('click', () => {
        document.body.classList.add('is-sub-mobile-open')
      })
    }

    if (close) {
      close.addEventListener('click', () => {
        document.body.classList.remove('is-sub-mobile-open')
      })
    }
  }

  const init = () => {
    initSmoothScroll()
    toggleMobileSubLinks()
    toggleMobileMenu()
  }

  return {
    init,
  }
})()

export default NavbarManager
